/* Cart helpers:
   1) Hold-timer countdown (sessionStorage-backed; persists across drawer + cart page).
   2) Drawer reorder: the upsell app injects "You may also like" as the FIRST child of
      <cart-drawer>, above the cart. Move it to sit BELOW the cart items (before the
      totals/checkout block), re-applied whenever the drawer re-renders. */
(function () {
  if (window.__msHold) return; window.__msHold = 1;
  var KEY = 'ms_hold_until', DUR = 10 * 60 * 1000;

  function until() {
    var u = sessionStorage.getItem(KEY);
    if (!u) { u = String(Date.now() + DUR); sessionStorage.setItem(KEY, u); }
    return parseInt(u, 10);
  }
  function tick() {
    var els = document.querySelectorAll('[data-ms-hold-time]');
    if (!els.length) return;
    var ms = until() - Date.now();
    els.forEach(function (e) {
      var box = e.closest('.ms-hold') || e;
      if (ms <= 0) { box.style.display = 'none'; return; }
      var m = Math.floor(ms / 60000), s = Math.floor((ms % 60000) / 1000);
      e.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    });
  }

  function reorderDrawer() {
    var d = document.getElementById('cart-drawer');
    if (!d) return;
    var inner = d.querySelector(':scope > .cart-drawer__inner');
    var foot = d.querySelector(':scope > .ms-cart-drawer__foot');
    if (!inner) return;
    var kids = Array.prototype.slice.call(d.children);
    for (var i = 0; i < kids.length; i++) {
      var c = kids[i];
      if (c === inner || c === foot) continue;
      if (/^(SCRIPT|STYLE|TEMPLATE)$/.test(c.tagName)) continue;
      if (c.getAttribute && c.getAttribute('slot')) continue;
      // c is the app-injected upsell — it belongs after the items (before the totals block)
      var inPlace = (c.previousElementSibling === inner) && (!foot || c.nextElementSibling === foot);
      if (inPlace) continue;
      if (foot) d.insertBefore(c, foot);
      else if (inner.nextSibling) d.insertBefore(c, inner.nextSibling);
      else d.appendChild(c);
    }
  }

  var raf = null;
  function scheduleReorder() { if (raf) return; raf = requestAnimationFrame(function () { raf = null; reorderDrawer(); }); }

  function initObserver() {
    var d = document.getElementById('cart-drawer');
    if (!d || d.__msObs) return; d.__msObs = 1;
    scheduleReorder();
    new MutationObserver(scheduleReorder).observe(d, { childList: true, subtree: true });
  }

  function init() { tick(); reorderDrawer(); initObserver(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', init);
})();
